<app-context-menu-item title="Open" [close]="true" (execute)="handleOpen()" />
@if (!folder()?.deleted) {
<app-context-menu-item [title]="flagLabel()" [close]="true" (execute)="flag()" />
<app-context-menu-item [title]="pinLabel()" [close]="true" (execute)="pin()" />
<app-context-menu-item title="Duplicate" [close]="true" (execute)="duplicate()" />
<app-context-menu-item title="Add new board" popoverAppearance="dialog">
  <div class="box-border w-[var(--quick-form-dialog-width)]">
    <app-panel-board-create [folderId]="folder()?.id ?? null" (created)="openCreated($event)" />
  </div>
</app-context-menu-item>

<app-context-menu-divider />

<app-context-menu-item title="Rename Folder">
  <div class="rename">
    <div class="rename-title">Rename Folder</div>
    <app-simple-input
      class="rename-input"
      [inputFormControl]="renameControl"
      placeholder="Type the Name"
      (onEnter)="handleRename()"
    />
    @if (renameError(); as error) {
      <div class="mt-1 text-xs text-error">{{ error }}</div>
    }
    <div class="rename-buttons">
      <app-button2 class="rename-buttons-item" appearance="secondary" size="s" (click)="close()">Cancel</app-button2>
      <app-button2 class="rename-buttons-item" appearance="primary" size="s" (click)="handleRename()">Save</app-button2>
    </div>
  </div>
</app-context-menu-item>
}
<app-context-menu-divider />
@if (folder()?.deleted) {
  <app-context-menu-item title="Restore from Trash" [close]="true" (execute)="setState({ deleted: false })" />
  <app-context-menu-item title="Delete permanently" [close]="true" (execute)="delete()" />
} @else {
  <app-context-menu-item [title]="folder()?.snoozed ? 'Change snooze' : 'Snooze'">
    <app-postpone-context-menu appearance="snooze" [current]="folder()?.snoozed" [removeDisabled]="!folder()?.snoozed" (onSelect)="setState({ snoozed: $event })" (onRemove)="setState({ snoozed: null })" />
  </app-context-menu-item>
  @if (folder()?.snoozed && inSnoozedList()) { <app-context-menu-item [title]="followUpWording.removeSnooze()" [close]="true" (execute)="setState({ snoozed: null })" /> }
  <app-context-menu-item [title]="folder()?.followed ? 'Change follow-up' : 'Follow up'">
    <app-postpone-context-menu appearance="followUp" [current]="folder()?.followed" [removeDisabled]="!folder()?.followed" (onSelect)="setState({ followed: $event })" (onRemove)="setState({ followed: null })" />
  </app-context-menu-item>
  @if (folder()?.followed && inFollowUpList()) { <app-context-menu-item [title]="followUpWording.removeFollowUp()" [close]="true" (execute)="setState({ followed: null })" /> }
  <app-context-menu-item title="Add Knots"><app-add-knots [stitchItems]="summaries()" (close)="close()" /></app-context-menu-item>
  <app-context-menu-item title="Add Tags"><app-add-tags [stitchItems]="summaries()" (close)="close()" /></app-context-menu-item>
  <app-context-menu-item title="Add Connections"><app-add-connections [stitchItems]="summaries()" (close)="close()" /></app-context-menu-item>
  <app-context-menu-item title="Select All" [close]="true" (execute)="selectAll()" />
  <app-context-menu-item [title]="folder()?.archived ? 'Restore from Archive' : 'Archive'" [close]="true" (execute)="setState({ archived: !folder()?.archived })" />
  <app-context-menu-item title="Trash" [close]="true" (execute)="setState({ deleted: true })" />
}
